(function(){
  'use strict';

  var productNotes = {
    'Kenya': 'A meaningful everyday bracelet for Kenyan pride.',
    'USA': 'Classic red, white, and blue for daily wear.',
    'Brazil': 'Bright, joyful, and made to stand out.',
    'Colombia': 'A colorful statement bracelet with easy fit.'
  };

  function addStyles(){
    if(document.getElementById('fh-bestseller-elegance-css')) return;
    var style = document.createElement('style');
    style.id = 'fh-bestseller-elegance-css';
    style.textContent = [
      '.fh-home .fh-section--white{background:#fffdf8!important;}',
      '.fh-home .fh-section--white .fh-section__head{align-items:center!important;margin-bottom:26px!important;}',
      '.fh-home .fh-section--white .fh-section__head>div{max-width:780px!important;}',
      '.fh-home .fh-section--white .fh-section__head h2{letter-spacing:0!important;}',
      '.fh-bs-proof{display:flex;flex-wrap:wrap;gap:10px;margin:18px 0 0;}',
      '.fh-bs-pill{display:inline-flex;align-items:center;gap:7px;border:1px solid rgba(197,155,67,.38);background:#f4ead4;color:#5b4214;padding:8px 11px;font-size:12px;font-weight:900;letter-spacing:.04em;text-transform:uppercase;}',
      '.fh-bs-pill:before{content:"";width:7px;height:7px;background:#c59b43;border-radius:999px;}',
      '.fh-home .fh-section--white .fh-link{background:#080808!important;color:#fff!important;text-decoration:none!important;padding:13px 18px!important;border:1px solid #080808!important;display:inline-flex!important;align-items:center!important;gap:8px!important;}',
      '.fh-home .fh-products{gap:22px!important;}',
      '.fh-home .fh-product{position:relative!important;background:#fff!important;border:1px solid #e2d8c8!important;padding:14px!important;box-shadow:0 12px 28px rgba(56,43,19,.07)!important;transition:transform .25s ease,box-shadow .25s ease,border-color .25s ease!important;}',
      '.fh-home .fh-product:nth-child(n+5){display:none!important;}',
      '.fh-home .fh-product:hover{transform:translateY(-5px)!important;box-shadow:0 22px 46px rgba(56,43,19,.14)!important;border-color:rgba(197,155,67,.72)!important;}',
      '.fh-home .fh-product__image{background:linear-gradient(180deg,#fff 0%,#fbf6eb 100%)!important;margin-bottom:16px!important;padding:22px!important;border:1px solid #f0e6d4!important;position:relative!important;overflow:hidden!important;}',
      '.fh-home .fh-product__image:after{content:"";position:absolute;left:14px;right:14px;bottom:12px;height:1px;background:linear-gradient(90deg,transparent,#c59b43,transparent);opacity:.45;}',
      '.fh-bs-badge{position:absolute;left:14px;top:14px;z-index:2;background:#080808;color:#fff;padding:8px 10px;font-size:11px;font-weight:950;letter-spacing:.08em;text-transform:uppercase;}',
      '.fh-bs-save,.fh-bs-proofline{display:none!important;}',
      '.fh-home .fh-product__country{color:#9b7425!important;font-size:11px!important;margin-bottom:7px!important;}',
      '.fh-home .fh-product h3{font-size:20px!important;line-height:1.12!important;}',
      '.fh-home .fh-product__price{font-size:22px!important;}',
      '.fh-bs-compare{display:block;color:#8d8578;font-size:13px;text-decoration:line-through;font-weight:750;margin-top:3px;}',
      '.fh-product__trust{display:none!important;}',
      '.fh-bs-note{font-size:13px;line-height:1.4;color:#5e5547;margin-top:12px;min-height:38px;font-weight:650;}',
      '.fh-bs-cta{margin-top:14px;display:flex;align-items:center;justify-content:center;min-height:44px;background:#080808;color:#fff;font-size:14px;font-weight:950;text-transform:none;text-decoration:none;}',
      '.fh-bs-cta span{transform:translateX(0);transition:transform .2s ease;}',
      '.fh-product:hover .fh-bs-cta span{transform:translateX(4px);}',
      '@media(max-width:990px){.fh-home .fh-section--white .fh-section__head{display:block!important}.fh-home .fh-section--white .fh-link{margin-top:18px!important}.fh-bs-proof{gap:8px}.fh-bs-pill{font-size:10px;padding:7px 9px}.fh-home .fh-products{display:grid!important;grid-template-columns:repeat(2,minmax(0,1fr))!important;gap:12px!important}.fh-home .fh-product{padding:10px!important}.fh-home .fh-product__image{padding:14px!important;margin-bottom:12px!important}.fh-bs-badge{font-size:9px;padding:6px 7px}.fh-home .fh-product h3{font-size:16px!important}.fh-home .fh-product__price{font-size:17px!important}.fh-bs-note{display:none}.fh-bs-cta{min-height:40px;font-size:13px}.fh-bs-compare{font-size:11px}}'
    ].join('');
    document.head.appendChild(style);
  }

  function findBestSellerSection(){
    var headings = document.querySelectorAll('.fh-home .fh-section--white h2');
    for(var i=0;i<headings.length;i++){
      if(/best sellers/i.test(headings[i].textContent || '')) return headings[i].closest('.fh-section--white');
    }
    return null;
  }

  function getCountry(product){
    var country = product.querySelector('.fh-product__country');
    return country ? country.textContent.trim() : '';
  }

  function polishSection(){
    var section = findBestSellerSection();
    if(!section || section.dataset.fhBestsellerElegant === 'true') return;
    section.dataset.fhBestsellerElegant = 'true';

    var head = section.querySelector('.fh-section__head > div');
    if(head && !head.querySelector('.fh-bs-proof')){
      var proof = document.createElement('div');
      proof.className = 'fh-bs-proof';
      proof.innerHTML = '<span class="fh-bs-pill">4.9/5 verified buyers</span><span class="fh-bs-pill">Adjustable fit</span><span class="fh-bs-pill">Gift-ready</span>';
      head.appendChild(proof);
    }

    var shopAll = section.querySelector('.fh-link');
    if(shopAll) shopAll.textContent = 'Shop all bracelets →';

    var products = Array.prototype.slice.call(section.querySelectorAll('.fh-product'));
    products.forEach(function(product, index){
      if(index > 3){
        product.style.display = 'none';
        return;
      }

      var country = getCountry(product);
      var image = product.querySelector('.fh-product__image');
      if(image){
        image.querySelectorAll('.fh-bs-save').forEach(function(el){ el.remove(); });
        var badge = image.querySelector('.fh-bs-badge');
        if(!badge){
          badge = document.createElement('span');
          badge.className = 'fh-bs-badge';
          image.appendChild(badge);
        }
        badge.textContent = 'Best Seller';
      }

      var price = product.querySelector('.fh-product__price');
      if(price && !price.querySelector('.fh-bs-compare')){
        var compare = document.createElement('span');
        compare.className = 'fh-bs-compare';
        compare.textContent = '$24.99';
        price.appendChild(compare);
      }

      var meta = product.querySelector('.fh-product__meta > div');
      if(meta){
        meta.querySelectorAll('.fh-bs-proofline').forEach(function(el){ el.remove(); });
        if(!meta.querySelector('.fh-bs-note')){
          var note = document.createElement('div');
          note.className = 'fh-bs-note';
          note.textContent = productNotes[country] || 'A customer-loved Fahari flag bracelet.';
          meta.appendChild(note);
        }
      }

      if(!product.querySelector('.fh-bs-cta')){
        var cta = document.createElement('span');
        cta.className = 'fh-bs-cta';
        cta.innerHTML = '<span>Shop bracelet →</span>';
        product.appendChild(cta);
      }
    });
  }

  function init(){
    addStyles();
    polishSection();
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  window.addEventListener('load', init, {once:true});
  document.addEventListener('shopify:section:load', init);
})();
